import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../context';
import { ROUTES, ROLES } from '../constants';

export function AdminRoute() {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (user?.role !== ROLES.ADMIN) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return <Outlet />;
}
